import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://tenvosolutions.com";
const SITE_NAME = "Tenvo Business Solutions Pvt Ltd.";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

// Per-route metadata. Keep the keys in sync with the <Route path="...">s in App.js.
const META = {
  "/": {
    title: "Tenvo Business Solutions Pvt Ltd. | Custom Software & App Development",
    description:
      "Dive into the world of new software solutions and experience a surge of inspiration and innovation. Unleash the power of technology with us.",
  },
  "/service": {
    title: "Our Services | Tenvo Business Solutions Pvt Ltd.",
    description:
      "Cross-platform app development, end-to-end solutions, UI/UX design, backend & API development, app maintenance and cloud services from Tenvo Business Solutions.",
  },
  "/contact": {
    title: "Contact Us | Tenvo Business Solutions Pvt Ltd.",
    description:
      "Get in touch with Tenvo Business Solutions Private Limited — STPI Technology Incubation Centre, Tharamani, Chennai, Tamil Nadu.",
  },
};

const SEO = () => {
  const { pathname } = useLocation();
  const meta = META[pathname] || META["/"];
  const canonical = pathname === "/" ? `${SITE_URL}/` : `${SITE_URL}${pathname}`;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={DEFAULT_IMAGE} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
};

export default SEO;
